import React, { useState } from 'react';
import { migrateExistingUsers } from '../utils/migrateUsers';

const UserMigration = () => {
  const [migrationStatus, setMigrationStatus] = useState(null);
  const [isRunning, setIsRunning] = useState(false);

  const runMigration = async () => {
    setIsRunning(true);
    setMigrationStatus('Running migration...');
    
    try {
      const result = await migrateExistingUsers();
      if (result.success) {
        setMigrationStatus(
          `Migration completed successfully!\n` +
          `Total users found: ${result.totalUsers}\n` +
          `Existing users: ${result.existingUsers}\n` +
          `New users created: ${result.createdUsers}`
        );
      } else {
        setMigrationStatus(`Migration failed: ${result.error}`);
      }
    } catch (error) {
      setMigrationStatus(`Migration error: ${error.message}`);
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      margin: '20px', 
      border: '1px solid #ccc', 
      borderRadius: '8px',
      backgroundColor: '#f9f9f9'
    }}>
      <h3>User Migration Tool</h3>
      <p>This will create user documents in the users collection for existing users.</p>
      
      <button 
        onClick={runMigration}
        disabled={isRunning}
        style={{
          padding: '10px 20px',
          backgroundColor: isRunning ? '#ccc' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: isRunning ? 'not-allowed' : 'pointer'
        }}
      >
        {isRunning ? 'Running...' : 'Run Migration'}
      </button>
      
      {migrationStatus && (
        <div style={{
          marginTop: '20px',
          padding: '10px',
          backgroundColor: '#e9ecef',
          borderRadius: '4px',
          whiteSpace: 'pre-line'
        }}>
          {migrationStatus}
        </div>
      )}
    </div>
  );
};

export default UserMigration;